import React from 'react'

function Banner({id, children, className}) {
  return (
    <div className={`${className} text-center items-center bg-blueD text-white py-8 md:py-16 mb-20 `} id={id}>
      {children}
    </div>
  )
}

export default Banner
